import { Box, Modal, Switch } from "@mui/material";
import { useState, useEffect } from "react";
import closeIcon from "../../assets/icons/closeIcon.svg";
import "./RolesAndPermissions.css";
import {getPermissions, getRoles} from "../../apis/rolesAndPermissionsApi/rolesAndPermissionsApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "../../layouts/spinner/Spinner"
import PermissionActions from "../../components/RolesAndPermissionActions/RolesAndPermissionActions";
import { useSelector } from "react-redux";

const permissionDataInitialState={
  Create_Flg:null,
  Read_Flg:null,
  Update_Flg:null,
  SoftDelete_Flg:null,
}

const RolesAndPermissions = () => {
  const [loading,setLoading]=useState(false);
  const [roleList, setRoleList] = useState([""]);
  const [permissionList, setPermissionList] = useState([{}]);
  const [seletedRoleId, setSeletedRoleId] = useState(-1);
  const [selectedRoleTitle, setSelectedRoleTitle] = useState("");
 
  //Modal Vars
  const [openPermissionsModal, setOpenPermissionsModal] = useState(false);
  const [editPermissionId,setEditPermissionId]=useState(-1);
  const [editPermissionData,setEditPermissionData]=useState(permissionDataInitialState);


  /* useEffect ----Starts----*/
  useEffect(() => {
    getAllRoles();
  }, []);
  /* useEffect ----Ends----*/



  /* Functions -----Starts--------*/
  const getAllRoles=()=>{
    getRoles((res:any)=>{
      setRoleList(res);
    })
  }


  const handleShowPermissions = (roleId: number,roleName:string) => {
    setLoading(true);
    setOpenPermissionsModal(true);
    setSelectedRoleTitle(roleName);
    setSeletedRoleId(roleId);
    getPermissions(roleId,(res:any)=>{
      setPermissionList(res);
      setLoading(false);
    })
    
  };

  const handlePermissionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditPermissionData({
      ...editPermissionData,
      [event.target.name]: (event.target.checked?"Y":"N"),
    });
  };

   /* Functions -----Ends--------*/

  return (
    <>
      <div className="tab-page-layout-1">
        <div className="tab-page-layout-1-header">
          <div className="tab-page-layout-1-header-title-label">
            Roles and Permissions
          </div>
        </div>
        <div className="tab-page-layout-1-body">
          <div className="tab-page-layout-1-list-header">
            <div className="tab-page-layout-1-li-item  font-bold">Roles</div>
            <div className="tab-page-layout-1-li-item  font-bold"></div>
          </div>
          <ul
            className="tab-page-layout-1-list-section"
            id="client-list-section"
          >
            {roleList.map((item: any, i) => {
              return (
                <li
                  className="tab-page-layout-1-list-item-section"
                  key={i}
                  onClick={() => handleShowPermissions(item.Id,item.Role_Nm)}
                >
                  <div className="tab-page-layout-1-li-item">{item.Role_Nm}</div>
                </li>
              );
            })}
          </ul>

          <div className="tab-page-layout-1-list-footer config-list-footer"></div>
        </div>
      </div>



      {/* Show Permissions modal */}
      <Modal
        open={openPermissionsModal}
        aria-labelledby="edit-modal-modal-title"
        aria-describedby="edit-modal-modal-description"
      >
        <Box className="modal-1-box h-full">
          <div className="modal-1-header">
            <div className="modal-1-title">{selectedRoleTitle}</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                setEditPermissionId(-1);
                setOpenPermissionsModal(false);
              }}
            >
              <img src={closeIcon} className="icon-md" />
            </div>
          </div>
          <div className="permissions-table overflow-auto text-center grid-cl-1">
            {loading && <Spinner/>}
            {!loading && 
              <table id="DM-tables">
              <tr className="permissions-row">
                <th className="w-half">Permission Name</th>
                <th>Create</th>
                <th>Read</th>
                <th>Update </th>
                <th>Delete</th>
                <th>Actions</th>
              </tr>

              {permissionList.map((item: any, i) => {
              return (
                <tr className="permissions-row">
                  <td>{item.Permissions_Nm}</td>
                  <td>
                    {item.Permission_Id===editPermissionId && 
                      <Switch
                      size="small"
                      defaultChecked={item.Create_Flg==="Y"}
                      onChange={handlePermissionChange}
                      name="Create_Flg"
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                    
                    }
                     {item.Permission_Id!==editPermissionId && (
                        item.Create_Flg==="Y"?
                        <FontAwesomeIcon className='create-icon' icon={["fas", "check-circle"]} color="green" size="lg"/>
                        :<FontAwesomeIcon className='create-icon' icon={["fas", "xmark-circle"]} color="red" size="lg"/>
                        )
                      }
                    </td>
                  <td>
                    {item.Permission_Id===editPermissionId && 
                      <Switch
                      size="small"
                      defaultChecked={item.Read_Flg==="Y"}
                      onChange={handlePermissionChange}
                      name="Read_Flg"
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                    
                    }
                     {item.Permission_Id!==editPermissionId && (
                        item.Read_Flg==="Y" ?
                        <FontAwesomeIcon className='create-icon' icon={["fas", "check-circle"]} color="green" size="lg"/>
                        :<FontAwesomeIcon className='create-icon' icon={["fas", "xmark-circle"]} color="red" size="lg"/>
              )}
                    </td>
                  <td>{item.Permission_Id===editPermissionId && 
                      <Switch
                      size="small"
                      defaultChecked={item.Update_Flg==="Y"}
                      onChange={handlePermissionChange}
                      name="Update_Flg"
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                    
                    }
                     {item.Permission_Id!==editPermissionId && (
                        item.Update_Flg==="Y" ?
                        <FontAwesomeIcon className='create-icon' icon={["fas", "check-circle"]} color="green" size="lg"/>
                        :<FontAwesomeIcon className='create-icon' icon={["fas", "xmark-circle"]} color="red" size="lg"/>
              )}
                    </td>
                  <td>{item.Permission_Id===editPermissionId && 
                      <Switch
                      size="small"
                      defaultChecked={item.SoftDelete_Flg==="Y"}
                      onChange={handlePermissionChange}
                      name="SoftDelete_Flg"
                      
                    />
                    
                    }
                     {item.Permission_Id!==editPermissionId && (
                        item.SoftDelete_Flg==="Y" ?
                        <FontAwesomeIcon className='create-icon' icon={["fas", "check-circle"]} color="green" size="lg"/>
                        :<FontAwesomeIcon className='create-icon' icon={["fas", "xmark-circle"]} color="red" size="lg"/>
              )}
                    </td>
                  <td>
                     <PermissionActions
                      record={item}
                      roleId={seletedRoleId}
                      editPermissionData={editPermissionData}
                      setEditPermissionId={setEditPermissionId}
                      setEditPermissionData={setEditPermissionData}
                      permissionDataInitialState={permissionDataInitialState}
                      refreshPermissions={()=>handleShowPermissions(seletedRoleId,selectedRoleTitle)}
                     />
                    </td>
                </tr>
              )}
            )}
            </table>
            }
            
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default RolesAndPermissions;
